import { useEffect, useState } from "react";
import { ResponseError } from "./ErrorMessage";

export function useErrorResponse(error: ResponseError) {
  const [responseError, setResponseError] = useState(null);

  useEffect(() => {
    if (error?.response) {
      (async () => {
        setResponseError(await error?.response.json());
      })();
    }
  }, [error]);

  return responseError;
}
